import { localhostApi } from './localhost-api';
import { ApiClientBase } from '../framework/services/api-client-base';
import { IRefreshTokenResponse } from '../entities-generated/models/authentication/refresh-token-response';
import { isThisLocalhost } from '../framework/utils';

class AuthClientClass extends ApiClientBase {
  constructor() {
    super();

    this.host = isThisLocalhost() ? localhostApi : window.location.origin;
    this.host = this.host + '/api';
  }

  protected acquireToken(): Promise<string> {
    return Promise.resolve('');
  }
}
const AuthClient = new AuthClientClass();

class AuthenticationApiClientClass {
  public refreshApiTokens() {
    return AuthClient.get<IRefreshTokenResponse>('auth', true);
  }

  public getDevelopmentTokens() {
    return AuthClient.get<IRefreshTokenResponse>(`auth/development`, true);
  }

  public signOutRequestingDevice() {
    return AuthClient.del<void>(`auth`);
  }

  public signOutAllDevices() {
    return AuthClient.del<void>(`auth/all`);
  }
}

export const AuthenticationApiClient = new AuthenticationApiClientClass();